import { Component, OnInit } from "@angular/core";
import { BaseControlComponent } from "../../../../../../form-controls/components/base-control/base-control.component";
import { ContextInteractionService } from "../../../../../../form-controls/services/context-interaction.service";

@Component({
    selector: "app-report-pdf-viewer-data-config",
    templateUrl: "./report-pdf-viewer-data-config.component.html",
    styleUrls: ["./report-pdf-viewer-data-config.component.scss"],
    standalone: false
})
export class ReportPdfViewerDataConfigComponent extends BaseControlComponent implements OnInit {
    static componentName = "ReportPdfViewerDataConfigComponent";

    constructor(public readonly contextService: ContextInteractionService) { super(contextService); }

    ngOnInit() {
        
    }

}
